/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Blog Analytics page in the dashboard.
 * @dashobardPageBuilder
 */
export function blogAnalytics(): PageBuilderResult {
  return { pageId: '3272eb63-13c2-4e22-bf9f-66964d1d39a3' };
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Blog Posts page in the dashboard.
 * @dashobardPageBuilder
 */
export function blogPosts(): PageBuilderResult {
  return { pageId: 'c7b86028-b1d2-42b0-be1d-4c95b374fc7d' };
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Blog Writers page in the dashboard.
 * @dashobardPageBuilder
 */
export function blogWriters(): PageBuilderResult {
  return { pageId: 'b8c96d90-95d6-57de-9a97-0d44c4dfaa96' };
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Blog Tags page in the dashboard.
 * @dashobardPageBuilder
 */
export function blogTags(): PageBuilderResult {
  return { pageId: '06313e49-80f7-498e-99cd-312eab83f391' };
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Blog Comments page in the dashboard.
 * @dashobardPageBuilder
 */
export function blogComments(): PageBuilderResult {
  return { pageId: '77f77e2b-56b6-4fe5-8011-ed1ebfd95c0b' };
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Blog Monetization page in the dashboard.
 * @dashobardPageBuilder
 */
export function blogMonetization(): PageBuilderResult {
  return { pageId: '681cbbb9-800c-414f-856a-ad4be4e1b296' };
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Blog Categories page in the dashboard.
 * @dashobardPageBuilder
 */
export function blogCategories(): PageBuilderResult {
  return { pageId: 'fd3e1c66-89b0-44ee-b824-1a28cc1a6dde' };
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Blog Overview page in the dashboard.
 * @dashobardPageBuilder
 */
export function blogOverview(): PageBuilderResult {
  return { pageId: '7c8f91b9-0b65-47ee-92eb-37c1f9a4d410' };
}

/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Blog Settings page in the dashboard.
 * @dashobardPageBuilder
 */
export function blogSettings(): PageBuilderResult {
  return { pageId: '2718bafd-5769-487e-b162-4b4d747edf89' };
}

export interface PageBuilderResult {
  pageId: string;
  relativeUrl?: string;
}
